export interface SurveyFieldLabelSection {
  name: string;
  fields: readonly unknown[];
}

export interface SurveyFieldLabelField {
  name: string;
}

/**
 * Whether to show a field name label next to its value in survey submission views.
 * Shared by the web read-only renderer and SubmissionPDFDocument.
 */
export function shouldShowSurveyFieldLabel(
  section: SurveyFieldLabelSection,
  field: SurveyFieldLabelField,
): boolean {
  if (field.name === section.name) {
    return false;
  }
  return section.fields.length > 1;
}
